<template>
  <div class="timeline">
    <div
      v-for="(t, i) in list" :key="`${t.alertId || 'alert'}-${i}`" class="timeline-item"
      :class="kindOf(t.alertType)"
    >
      <div class="ti-head">
        <span class="tag" :class="clsOf(t.alertType)">
          {{ typeZh(t.alertType) }}<span class="pt"> / {{ typePt(t.alertType) }}</span>
        </span>
        <span class="ti-title">{{ t.uf }} · {{ t.title }}</span>
      </div>
      <div class="ti-time">{{ fmtTs(t.ts) }}</div>
      <div class="ti-body">
        {{ sendZh(t.sendStatus) }} · 接收群：{{ t.recipientName || '—' }}
        <span class="pt pt-block">{{ sendPt(t.sendStatus) }} · Grupo: {{ t.recipientName || '—' }}</span>
      </div>
    </div>
    <div v-if="!list.length" class="empty">暂无告警记录<span class="pt"> / Nenhum alerta</span></div>
  </div>
</template>

<script>
import { ALERT_TYPE_LABEL, SEND_STATUS_LABEL } from '../mock';

export default {
  name: 'AlertTimeline',
  props: {
    // 告警时间线（字段同接口 items：alertId / alertType / uf / title / sendStatus / recipientName / ts）
    list: { type: Array, default: () => [] }
  },
  methods: {
    /** 告警类型 → 时间线圆点配色类：1紧急 err / 2恢复 ok / 3警告 warn */
    kindOf(alertType) {
      return (ALERT_TYPE_LABEL[alertType] || {}).kind || 'ok';
    },
    /** 告警类型 → 标签配色类 */
    clsOf(alertType) {
      return (ALERT_TYPE_LABEL[alertType] || {}).cls || 'tag-ok';
    },
    /** 告警类型中文（紧急告警 / 恢复通知 / 警告通知） */
    typeZh(alertType) {
      return (ALERT_TYPE_LABEL[alertType] || {}).zh || '—';
    },
    /** 告警类型葡语（Crítico / Recuperação / Aviso） */
    typePt(alertType) {
      return (ALERT_TYPE_LABEL[alertType] || {}).pt || '—';
    },
    /** 发送状态中文（成功 / 失败） */
    sendZh(sendStatus) {
      return (SEND_STATUS_LABEL[sendStatus] || {}).zh || '—';
    },
    /** 发送状态葡语（Sucesso / Falha） */
    sendPt(sendStatus) {
      return (SEND_STATUS_LABEL[sendStatus] || {}).pt || '—';
    },
    /** 毫秒时间戳 → MM-DD HH:mm */
    fmtTs(ts) {
      if (!ts) return '—';
      const d = new Date(ts);
      if (isNaN(d.getTime())) return '—';
      const pad = n => String(n).padStart(2, '0');
      return `${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    }
  }
};
</script>

<style scoped lang="scss">
.timeline {
  padding: 8px 20px 16px;
  max-height: 500px;
  overflow-y: auto;
}
.timeline-item {
  position: relative;
  padding: 8px 0 14px 22px;
  border-left: 1px dashed #e5e6eb;
  margin-left: 8px;
}
.timeline-item::before {
  content: '';
  position: absolute;
  left: -5px;
  top: 10px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #00a551;
  box-shadow: 0 0 0 3px #fff, 0 0 0 4px #e8f7f0;
}
.timeline-item.warn::before {
  background: #ff7d00;
  box-shadow: 0 0 0 3px #fff, 0 0 0 4px #fff3e0;
}
.timeline-item.err::before {
  background: #f53f3f;
  box-shadow: 0 0 0 3px #fff, 0 0 0 4px #ffecec;
}
.timeline-item .ti-head {
  display: flex;
  gap: 8px;
  align-items: center;
  font-weight: 600;
  font-size: 13px;
  flex-wrap: wrap;
}
.timeline-item .ti-title {
  min-width: 0;
}
.timeline-item .ti-time {
  color: #86909c;
  font-size: 12px;
  margin-top: 2px;
}
.timeline-item .ti-body {
  font-size: 12px;
  color: #4e5969;
  margin-top: 4px;
  line-height: 1.6;
}
.pt {
  font-size: 12px;
  font-weight: 400;
  color: #86909c;
}
.pt-block {
  display: block;
  margin-top: 1px;
}
.tag {
  display: inline-flex;
  align-items: center;
  padding: 1px 8px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 4px;
  line-height: 18px;
  white-space: nowrap;
  flex-shrink: 0;
}
.tag-ok { background: #e8f7e9; color: #00b42a; }
.tag-err { background: #ffecec; color: #f53f3f; }
.tag-warn { background: #fff3e0; color: #ff7d00; }
.empty {
  padding: 24px;
  text-align: center;
  color: #86909c;
  font-size: 13px;
}
</style>
